import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useApi } from '../../hooks/useApi';
import { useAuthUserContext } from '../../providers/AuthUser';
import { Conv } from '../../models/Conv';
import { Kyc, ApiKyc } from '../../models/Kyc';
import { UserType } from '../../types';
import Spinner from '../../components/Spinner';

type MessageFormProps = {
  activeConv?: Conv;
  selectConv: (conv?: Conv) => void;
}

const MessageForm = ({ activeConv, selectConv }: MessageFormProps) => {
  const [ bodyContent, setBodyContent ] = useState<string>();
  const [ kyc, setKyc ] = useState<Kyc>();
  const { get, post, loading } = useApi();
  const { user } = useAuthUserContext();

  const isDonee = user?.userType === UserType.Donee;

  const isKycSubmitted = kyc && ['SUBMITTED', 'AUTO_CERTIFIED', 'MAN_CERTIFIED'].includes(kyc.status);

  useEffect(() => {
    get({
      endpoint: '/api/v1/kycs/me',
      onSuccess: (data) => {
        const apiKyc: ApiKyc = data.data;
        setKyc(new Kyc(apiKyc));
      }
    })
  }, [ get ]);

  const sendBody = () => {
    if (!bodyContent) return;

    post({
      endpoint: `/api/v1/convs/${ activeConv?.id }/add_message`,
      body: {
        conv_id: activeConv?.id,
        message_body: bodyContent
      },
      onSuccess: (res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("メッセージを送信しました");
          setBodyContent("");
          activeConv && selectConv(activeConv);
        }
      },
      onError: (err) => {
        toast.error("送信に失敗しました。時間をおいて再度お試しください。");
      },
    });
  }

  return (
    <div className="form">
      <textarea
        cols={ 30 }
        rows={ 10 }
        placeholder="※ここにメッセージを入力してください"
        value={ bodyContent }
        onChange={ e => setBodyContent(e.target.value) }
      />
      <button
        type="submit"
        className={ isDonee ? "w_pinkbtn" : "w_bluebtn" }
        onClick={ () => sendBody() }
        disabled={ loading || !bodyContent }
      >
        { loading ? <Spinner size="small" color={ isDonee ? "pink" : "blue" } /> : "送信する" }
      </button>
      { !isKycSubmitted &&
        <p><Link to="/mypage/kyc">こちら</Link>から本人確認を行なってください。</p>
      }
    </div>
  );
}

export default MessageForm;
